<template>
  <div class="Map-Plan">
    <div class="Plan-Day hiddenScrollbar">
      <!--      左侧行程节点-->
      <tripLeftDay class="Left-Day hiddenScrollbar" :chenckBudget = "chenckBudget"></tripLeftDay>
    </div>
    <div class="Plan-Budget hiddenScrollbar">
      <div class="Ver"></div>
      <!--      行程详情-->
      <PlanShare ref="planShare"></PlanShare>
    </div>
    <div class="MP-Right">
      <div class="State-Top">
        <div class="City-Check">
          <span class="CC" v-for="(city,cityIndex) in checkCitys" @click="changeCity(cityIndex)" :key="cityIndex">{{city.cityName}}</span>
        </div>
        <div class="Option-Button">
          <el-button type="primary" class="" @click="planShow(0)" size="mini">产品分布图展示</el-button>
          <el-button type="primary" style="margin-right: 5px;" class="" @click="planShow(1)" size="mini">行程图展示</el-button>
          <el-tooltip effect="dark" content="返回图文模式" placement="top">
            <img type="primary" class="R-Plan" @click="toPlan" src="@/assets/png/PicAndFont.png" alt="返回图文模式" />
          </el-tooltip>
        </div>
      </div>
      <div v-show="planType == 0" class="State-Map">
        <el-radio-group v-model="state" @change="stateChange($event,baiduMapDate)">
          <el-radio v-for="(stateMap,stateIndex) in stateList" :key="stateIndex" :label="stateMap.state">
            <img class="SM-Icon" :src="stateMap.imageUrl" alt="">
            <span style="margin-left: 0.1rem;font-weight: 700;">{{ stateMap.typeName }}</span>
          </el-radio>
        </el-radio-group>
      </div>
      <baiduMap v-if="stateList.find(x=>x.state == state) && planType == 0" ref="map" :key="mapKey"></baiduMap>
      <createPlanMap v-if="planType == 1" ref="createPlanMap" :citys="mapCityArr"></createPlanMap>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import baiduMap from '@/views/plan/mapPlanFlod/baiduMap'
import { stockTypeMapList } from '@/assets/utils/commonData'
import tripLeftDay from '@/views/plan/leftMoudle/tripLeftDay'
import { getPlanInfo } from './js/function'
import { mapState } from 'vuex'
import PlanShare from '@/views/plan/mapPlanFlod/budgetMiddle/PlanShare'
import createPlanMap from './mapPlanFlod/createPlanMap.vue'
export default {
  name:  '',
  components: {
    baiduMap,tripLeftDay,PlanShare,createPlanMap
  },
  // 定义属性
  data() {
    return {
      state: 0,
      stateList: stockTypeMapList,
      chenckBudget: '',
      checkCitys: [],
      baiduMapDate: {},
      checkCityIndex: 0,
      planType: 0,
      mapCityArr:[],
      mapKey: 0
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapState(['planId']),
    ...mapState(['budgetMainId'])
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //获取行程信息
    _getPlanDayInfo() {
      getPlanInfo(this.planId,this.budgetMainId)
    },
    //返回图文模式
    toPlan() {
      this.$router.push({name: 'plan'})
      setTimeout(() => {
        location.reload();
      }, 100);
    },
    planShow(type) {
      this.planType = type;
      if (type == 1) {
        this.$nextTick(() => {
          this.$refs.createPlanMap.initMap(false);
        })
      }
    },
    stateChange(e,data) {
      this.mapKey++
      setTimeout(() => {
        if (this.stateList.length > 0 && this.planType == 0) {
          this.$refs.map.initMap(this.stateList.find(x => x.state === e),data)
          this.$refs.map.setCenter(this.checkCityIndex)
        }
      }, 1000);
    },
    changeCity(cityIndex) {
      this.checkCityIndex = cityIndex
      this.$refs.map.setCenter(this.checkCityIndex)
      this.$refs.map.loading = true
      this.$refs.map.planMap.clearOverlays()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if(this.$route.query.type) {
      this.planShow(this.$route.query.type)
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this._getPlanDayInfo()
    this.$Bus.$on('changePlanInfo',data=>{
      console.log("触发了changePlanInfo")
      this.chenckBudget = data.budgetMain
      this.chenckBudget.planDayList.forEach(item=>{
        this.$set(item,'inputShowState',false)
      })
      this.checkCitys = this.chenckBudget.planDayList[0].cityList
      this.mapCityArr = []
      this.chenckBudget.planDayList.forEach(item => {
        let cityArr = [...(item.cityList.filter(u=>u.longitude!=='' && u.latitude!==''))]
        let _filterCitys =  cityArr.filter(u => u.countryId == 8)
        if (_filterCitys.length < 3) {
          this.mapCityArr.push(...cityArr.filter(u => u.countryId != 8))
        } else {
          this.mapCityArr.push(...cityArr)
        }
      })
      console.log('dlfkjgikjfdg',this.mapCityArr)

      this.$nextTick(() => {
        //默认查询第一个城市
        this.baiduMapDate = this.chenckBudget.planDayList[0]
        this.stateChange(this.state,this.baiduMapDate)
      })
      this.$refs.planShare.init(this.chenckBudget.id,this.chenckBudget.planId)
    })
    this.$Bus.$on('checkPlanObj', (data,data1) => {
      console.log("触发了checkPlanObj")
      console.log('citys',data,data1)
      this.checkCitys = data.cityList
      //获取参数
      this.$nextTick(() => {
        //默认查询第一个城市
        this.baiduMapDate = data
        this.stateChange(this.state,this.baiduMapDate)
      })
    })
    this.$Bus.$on('addCity',data => {
      this.mapCityArr.push(data)
      this.$refs.createPlanMap.drawALine()
    })
    //删除城市
    this.$Bus.$on('delCity',planCityIdAndPlanDay => {
      console.log('cityId',planCityIdAndPlanDay,this.mapCityArr)
      if (this.mapCityArr.length > 0) {
        let index = this.mapCityArr.findIndex(x => x.id === planCityIdAndPlanDay.planCityId && x.planDay === planCityIdAndPlanDay.planDay)
        if (index > -1) {
          this.mapCityArr.splice(index,1)
          console.log('11111',this.mapCityArr)
          this.$refs.createPlanMap.removeMarker()
          this.$refs.createPlanMap.drawALine()
        }
      }
    })
  },
  beforeDestroy(){
    this.$Bus.$off("changePlanId");
    this.$Bus.$off("changeBudgetInfo");
    this.$Bus.$off("addCity");
    this.$Bus.$off("delCity");
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
  .Map-Plan {
    display: flex;
    justify-content: center;
    .Plan-Budget {
      .Ver {
        position: sticky;
        top: 0;
        height: 10px;
        z-index: 1;
        background: white;
      }
      overflow-y: scroll;
      background: white;
      position: relative;
      top: 10px;
      margin-left: 7px;
      border-radius: 10px;
      box-shadow: 0px 0.01rem 0.1rem 0px #dddddd;
    }
    .Plan-Day {
      position: relative;
      top: 10px;
      overflow-y: scroll;
      background: white;
      border-radius: 10px;
      box-shadow: 0px 0.01rem 0.1rem 0px #dddddd;
    }
    .Left-Day {
      height: 100px;
      overflow-y: scroll;
    }
    /deep/ .left {
      >div:last-child{
        position: inherit !important;

      }
      >div:first-child{
        position: sticky;
        top: 0;
      }
    }
    .MP-Right{
      padding: 10px;
      width: 10rem;
      // position: absolute;
      // right: 0;
      border-radius: 10px;
      box-shadow: 0px 0.01rem 0.1rem 0px #dddddd;
      .State-Top {
        display: flex;
        justify-content: space-between;
        height: 30px;
        background: whitesmoke;
        border-bottom: 1px solid lightgray;
        .Option-Button {
          display: flex;
          margin-right: 10px;
          >button {
            height: 23px;
            margin-top: 3.5px;
          }
          .R-Plan {
            height: 25px;
            width: 25px;
            margin-top: 3.5px;
            &:hover {
              cursor: pointer;
            }
          }
          /deep/ .el-tooltip__popper  {
            width: auto !important;
          }
        }
        .City-Check {
          display: inline-flex;
          align-items: center;
          padding-left: 10px;
          .CC:hover {
            cursor: pointer;
            color: red;
            text-decoration: underline;
          }
          .CC::after {
            content: ">";
            display: inline-block;
            color: black;
            margin-left: 2px;
            margin-right: 2px;
            text-decoration: none;
          }
          .CC:last-child::after {
            content: "";
          }
        }
      }
      .State-Map {
        /deep/ .el-radio-group {
          height: 30px;
          display: flex;
          align-items: center;
        }
        /deep/ .el-radio__inner {
          display: none;
        }
        /deep/ .el-radio {
          height: 30px;
          padding-left: 5px;
          padding-right: 5px;
          display: flex;
          align-items: center;
        }

        .SM-Icon {
          width: 0.2rem;
          height: 0.2rem;
          position: relative;
          top: 0.035rem
        }
        height: 30px;
        background: whitesmoke;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid lightgray;
      }
    }
  }
</style>
